var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.messageComponent,{tag:"component",attrs:{"message":_vm.message,"has-next":_vm.hasNext,"same-minute":_vm.isWithinSameMinute}},[(_vm.isBubble)?_c(_vm.messageTypeComponent,{tag:"component",attrs:{"message":_vm.message}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }